import { IForm } from '@/components/types'
import { useSearchVideoTitle, useSearchDuration } from '@/hooks/useSearch'

const [fetchSuggestions] = useSearchVideoTitle()
const durationOptions = useSearchDuration()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'autocomplete',
      label: '视频标题',
      placeholder: '请输入视频标题',
      otherOptions: {
        clearable: true,
        'fetch-suggestions': fetchSuggestions
      }
    },
    {
      field: 'consumerNickName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'consumerWxUnionId',
      type: 'input',
      label: '客户unionid',
      placeholder: '请输入客户unionid'
    },
    {
      field: 'duration',
      type: 'select',
      label: '访问时长',
      clearable: true,
      placeholder: '请选择访问时长',
      options: durationOptions
    },
    {
      field: 'accessTime',
      type: 'datepicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    }
  ]
}
